module.exports = __webpack_public_path__ + "static/media/make_payment_button.448c3c29.svg";